// UEFA Nations League 2026/27 participants. Reuse existing country artwork;
// additional badges belong in public/images/nationsleague (exact names below).
export const NATIONS_LEAGUE_TEAMS = [
  'Albania', 'Andorra', 'Armenia', 'Austria', 'Azerbaijan', 'Belarus',
  'Belgium', 'Bosnia and Herzegovina', 'Bulgaria', 'Croatia', 'Cyprus',
  'Czechia', 'Denmark', 'England', 'Estonia', 'Faroe Islands', 'Finland',
  'France', 'Georgia', 'Germany', 'Gibraltar', 'Greece', 'Hungary',
  'Iceland', 'Israel', 'Italy', 'Kazakhstan', 'Kosovo', 'Latvia',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta', 'Moldova',
  'Montenegro', 'Netherlands', 'North Macedonia', 'Northern Ireland',
  'Norway', 'Poland', 'Portugal', 'Republic of Ireland', 'Romania',
  'San Marino', 'Scotland', 'Serbia', 'Slovakia', 'Slovenia', 'Spain',
  'Sweden', 'Switzerland', 'Türkiye', 'Ukraine', 'Wales',
];

const EXISTING_WORLD_CUP_LOGOS = new Set([
  'Austria', 'Belgium', 'Bosnia and Herzegovina', 'Croatia', 'Czechia',
  'England', 'France', 'Germany', 'Netherlands', 'Norway', 'Portugal',
  'Scotland', 'Spain', 'Sweden', 'Switzerland', 'Türkiye',
]);

const normalizeName = (name) => String(name || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const TEAM_NAMES = Object.fromEntries(
  NATIONS_LEAGUE_TEAMS.map((name) => [normalizeName(name), name])
);

const ALIASES = {
  'bosnia herzegovina': 'Bosnia and Herzegovina',
  'bosnia': 'Bosnia and Herzegovina',
  'czech republic': 'Czechia',
  'ireland': 'Republic of Ireland',
  'republic ireland': 'Republic of Ireland',
  'macedonia': 'North Macedonia',
  'turkey': 'Türkiye',
};

export const getNationsLeagueLogoPath = (teamName) => {
  const key = normalizeName(teamName);
  const filename = ALIASES[key] || TEAM_NAMES[key];
  if (!filename) return null;
  const folder = EXISTING_WORLD_CUP_LOGOS.has(filename) ? 'worldcup' : 'nationsleague';
  return `/images/${folder}/${encodeURIComponent(filename)}.png`;
};
